import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { ReactiveFormsModule, FormsModule, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
const google_oauth_client_id: string = "498964568914-vqkvredlcutjuna0tn1i56f8jpb9jp4h.apps.googleusercontent.com";
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../../Services/shared.service';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { environment } from '../../../../../environments/environment';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthService } from 'angularx-social-login';
//import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthService } from 'angularx-social-login';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  step: string = 'login';
  object: any;
  isEmailLoginMode = false;
  otpEmailStatus: boolean = false;
  OTPStatus: boolean = false;
  ResendOTPButton: boolean = false


  constructor(private _fb: FormBuilder, public _svc: SharedService, private _router: Router
    , private _authService: SocialAuthService, private _activatedRoute: ActivatedRoute
  ) { }
  get _form() { return this.object.controls }
  ngOnInit(): void {
    this.changeStep(this.step);

  }
  changeStep(newStep: string): void {
    this.step = newStep;
    const stepActions: { [key: string]: () => void } = {
      login: () => this.LoginForm(),
      register: () => this.registerForm(),
      forgot: () => this.ForgotPassword()
    };
    stepActions[this.step]?.();
  }
  LoginForm() {

    this.object = this._fb.group({
      emailId: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.minLength(3)]]
    })
  }
  registerForm() {

    this.object = this._fb.group({
      name: [null, [Validators.required, Validators.minLength(3)]],
      emailId: [null, [Validators.required, Validators.email]],
      Password: [null, [Validators.required, Validators.minLength(3)]],
      MobileNumber: [null, [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      confirmpassword: [null, [Validators.required, Validators.minLength(3)]],
    }, { validators: this.matchPasswordsValidator });
  }

  ForgotPassword() {
    this.object = this._fb.group({
      emailId: [null, [Validators.required, Validators.email]],
    })
  }
  onForgotPassword(): void {
    if (this.object.valid) {
      this._svc.GET(API_End_Point.ForgotPassword(this.object.value.emailId)).subscribe((res: any) => {
        this._svc.Notification(res.result, res.message);
      });
    }
  }

  LoginWithSocialMedia(provider: string): void {
    if (provider === 'Email') {
      this.isEmailLoginMode = true;
    }
    else {
      const platform = provider === 'Facebook' ? FacebookLoginProvider.PROVIDER_ID : GoogleLoginProvider.PROVIDER_ID;
      this._authService.signIn(platform).then((res: any) => {
        const payload = { emailId: res.email || '', password: '**', socialMediaDetails: { socialMedia: provider, name: res.name || '', photoUrl: res.photoUrl || '' } };
        this.login(payload);
      });
    }
  }
  login(payload?: any): void {

    const data = payload || this.object?.value;
    if (!data)
      return this._svc.Notification('Error', 'Invalid form data');
    const finalPayload = { emailId: data.emailId || '', password: data.password || '', socialMediaDetails: data.socialMediaDetails || { socialMedia: '', name: data.name || '', photoUrl: data.photoUrl || '' } };
    this._svc.POST(finalPayload, API_End_Point.Login).subscribe((res: any) => {
      const result = (res?.result || '').toLowerCase();
      const isSuccess = result === (environment.Success || '').toLowerCase();
      if (isSuccess) {
        if (!res.token) {
          this._svc.Notification(res.result, res.message || 'Token missing in response');
          return;
        }
        debugger
        localStorage.setItem('PREP_UserInfo', JSON.stringify({ ...res.data, loginDate: new Date().toLocaleDateString() }));
        localStorage.setItem('token', res.token);
        if (this._activatedRoute.snapshot.queryParamMap.get('return') != undefined) {
          var returnURL = this._activatedRoute.snapshot.queryParamMap.get('return') || "";

          returnURL = returnURL.split("?")[0];
          this._router.navigateByUrl('' + returnURL);
        } else
          this._router.navigate(['/dashboard']);
      } else {
        this._svc.Notification(res.result, res.message || 'Login failed');
      }
    });
  }

  RegisterForm(): void {
    this._svc.POST(this.object.value, API_End_Point.Register).subscribe((res: any) => {
      this._svc.Notification(res.result, res.message);
      if (res.result?.toLowerCase() === environment.Success.toLowerCase()) {
        this.otpEmailStatus = false;
        this.OTPStatus = false;
        setTimeout(() => this.changeStep('SuccessNewReg'), 500);
      }
    });
  }


  sendOTP(email: string): void {
    this._svc.GET(API_End_Point.SendOTP(email)).subscribe(
      (res: any) => {
        if (res.result?.toLowerCase() === environment.Success.toLowerCase()) {
          this.OTPStatus = true;
          this.ResendOTPButton = true;
          setTimeout(() => { this.ResendOTPButton = false; }, 300000); // 5 minutes
        }
        if (res.message == "OTP already sent to your registered email ID!") {
          this.OTPStatus = true;
          this.ResendOTPButton = true;
          setTimeout(() => { this.ResendOTPButton = false; }, 240000); // 4 minutes
        }
        this._svc.Notification(res.result, res.message);
      }
    );
  }


  VeriFyEmailOtp(otp: string) {
    debugger
    if (!otp || otp.trim() === '') {
      this._svc.Notification('Error', 'Please enter a valid OTP.');
      return;
    }
    this._svc.GET(API_End_Point.VerifyEmailOTP(this.object.value.emailId, otp)).subscribe((res: any) => {
      if (res.result?.toLowerCase() === environment.Success.toLowerCase()) {
        this.OTPStatus = false;
        this.otpEmailStatus = true;
      }
      this._svc.Notification(res.result, res.message);
    });
  }

  matchPasswordsValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const Password = group.get('Password')?.value;
    const confirmpassword = group.get('confirmpassword')?.value;
    return Password === confirmpassword ? null : { passwordsMismatch: true };
  };

  BackToLogin() {
    window.location.href = '/login';
  }
  onActivate(event: any) {
    // window.scroll(0,0);

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });


  }

  showPassword = true;

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}

